import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Col,
  Row,
  Input,
  FormFeedback,
  Form,
} from "reactstrap"

import { useSelector } from "react-redux"
import { useFormik } from "formik"
import Spinners from "components/Common/Spinner"
import eye from "../../../assets/images/icons/eye.svg"
import * as Yup from "yup"
import { useInvestorUpdatePasswordMutation } from "store/api/investorapi/auth.api"
import { useWealthPartnerUpdatePasswordMutation } from "store/api/wealthpartnerapi/auth/auth.api"
import { useUpdatePaswwordMutation } from "store/api/platformManager/platformManager.api"
import closeIcon from "../../../assets/images/icons/close.svg"
import hide from "../../../assets/images/icons/hide.svg"
import toast from "react-hot-toast"

const initialValues = {
  currentPassword: "",
  password: "",
  confirmNewPassword: "",
}

const ChangePassowrd = ({ open, setOpen }) => {
  const { user, userType } = useSelector((state) => state.user)
  const [mutate, { isLoading: isUpdating }] = useUpdatePaswwordMutation()
  const [investorMutate, { isLoading }] = useInvestorUpdatePasswordMutation()
  const [wealthMutate, { isLoading: isWealthLoading }] =
    useWealthPartnerUpdatePasswordMutation()
  const [show, setShow] = useState(false)
  const toggle = () => setOpen(!open)

  const validation = useFormik({
    initialValues,
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  const onFormSubmit = async (values) => {
    try {
      const mutations = {
        INVESTOR: investorMutate,
        WEALTH_PARTNER: wealthMutate,
        ADMIN: mutate,
      }

      const mutationFn = mutations[userType]
      if (mutationFn) {
        const { success, message } = await mutationFn(values).unwrap()
        if (success) {
          validation.setValues({ ...initialValues })
          setOpen(false)
          toast.success(message, { id: "toastMessage" })
        }
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }
  return (
    <React.Fragment>
      <Modal isOpen={open} centered className="custom-size" size="md">
        <ModalBody className="p-3">
          <Row>
            <Col xl={12}>
              <div className="platform-heading-section my-4 d-flex justify-content-between mt-0">
                <div>
                  <h4>Change Password</h4>
                  <p>
                    Please enter your current password to change <br /> your
                    password.
                  </p>
                </div>
                <div onClick={toggle}>
                  <img className="cp" src={closeIcon} alt="" height={"14px"} />
                </div>
              </div>
              <hr />
            </Col>
          </Row>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <FormGroup row>
              <Label className="form-label" md={4}>
                Current password <span className="error">*</span>
              </Label>
              <Col md={8}>
                <Input
                  id=""
                  name="currentPassword"
                  placeholder="Current password"
                  type={show ? "text" : "password"}
                  className="form-control"
                  value={validation.values.currentPassword}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.currentPassword &&
                    !!validation.errors.currentPassword
                  }
                />
                {validation.touched.currentPassword &&
                validation.errors.currentPassword ? (
                  <FormFeedback type="invalid">
                    {validation.errors.currentPassword}
                  </FormFeedback>
                ) : null}
              </Col>
              <hr className="mt-3" />
            </FormGroup>
            <FormGroup row>
              <Label className="form-label" md={4}>
                New password <span className="error">*</span>
              </Label>
              <Col md={8}>
                <Input
                  id=""
                  name="password"
                  placeholder="New password"
                  type={show ? "text" : "password"}
                  className="form-control"
                  value={validation.values.password}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.password && !!validation.errors.password
                  }
                />
                {validation.touched.password && validation.errors.password ? (
                  <FormFeedback type="invalid">
                    {validation.errors.password}
                  </FormFeedback>
                ) : null}
              </Col>
              <hr className="mt-3" />
            </FormGroup>
            <FormGroup row className="mb-2">
              <Label className="form-label" md={4}>
                Confirm new password <span className="error">*</span>
              </Label>
              <Col md={8}>
                <div className="input-wrapper">
                  <Input
                    id=""
                    name="confirmNewPassword"
                    placeholder="Confirm new password"
                    type={show ? "text" : "password"}
                    className="form-control"
                    value={validation.values.confirmNewPassword}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.confirmNewPassword &&
                      !!validation.errors.confirmNewPassword
                    }
                  />

                  <div
                    onClick={() => setShow((prev) => !prev)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {show ? (
                      <img src={hide} alt="" />
                    ) : (
                      <img src={eye} alt="" />
                    )}
                  </div>
                </div>
                {validation.touched.confirmNewPassword &&
                validation.errors.confirmNewPassword ? (
                  <FormFeedback type="invalid">
                    {validation.errors.confirmNewPassword}
                  </FormFeedback>
                ) : null}
              </Col>
            </FormGroup>
            <Row className="justify-content-end my-4">
              <Col sm={12}>
                <div className="d-flex justify-content-end align-items-center gap-3">
                  <button
                    type="button"
                    onClick={toggle}
                    className="btn btn-cancel w-md"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary w-md"
                    disabled={isLoading || isWealthLoading || isUpdating}
                  >
                    {isLoading || isWealthLoading || isUpdating ? (
                      <Spinners />
                    ) : (
                      "Update password"
                    )}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default ChangePassowrd
